import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getStatusId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusId
}

export const getId = (state, props) => props.cardContext.id

export const getSubCards = (state, props) => {
  return state['view-card'].subCards[props.cardContext.id]
}

export const subCardIdsSelector = createSelector(
  [getSubCards],
  (subCards) =>
    Object.keys(subCards).map(key => subCards[key].cardId)
)

export default createSelector(
  [
    getBoardId,
    getStatusId,
    getId,
    subCardIdsSelector,
  ],
  (
    boardId,
    statusId,
    id,
    subCardIds,
  ) => ({
    boardId,
    statusId,
    id,
    subCardIds,
  })
)
